import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoriesSection() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            攻略分类
          </h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">
            从入门到精通，五大分类覆盖2048全部核心知识点，选择你感兴趣的方向开始学习
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group bg-background-50 border border-background-200/70 rounded-xl p-5 hover:bg-primary-50 hover:border-primary-200 transition-all duration-300"
            >
              <div className="w-11 h-11 flex items-center justify-center bg-primary-100 rounded-xl mb-4 group-hover:bg-primary-500 transition-colors duration-300">
                <i className={`${cat.icon} text-primary-600 group-hover:text-background-50 text-lg transition-colors duration-300`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-2 whitespace-nowrap">
                {cat.name}
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2 mb-3">
                {cat.description}
              </p>
              <span className="text-xs text-primary-600 font-medium">
                {cat.articleCount} 篇文章
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}